import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {GridDataResult, PageChangeEvent, PagerSettings} from "@progress/kendo-angular-grid";
import {CaixaService} from "../services/caixa.service";
import {ImpressaoService} from "../../services/impressao.service";
import {ConstantsService} from "../../fidelidade/ConstantsService";
import {DialogRef, DialogService} from "@progress/kendo-angular-dialog";

@Component({
  selector: 'app-historico-de-caixa',
  templateUrl: './historico-de-caixa.component.html',
  styleUrls: ['./historico-de-caixa.component.scss']
})
export class HistoricoDeCaixaComponent implements OnInit {
  @ViewChild('aguardeImpressao')
  public templateref: TemplateRef<any>;

  private dialogRef: DialogRef;
  historicoCaixas: GridDataResult = {
    data: [],
    total: 0
  };
  carregando: any;
  skip = 0;
  pageSize = 10;
  pageSizes = [10, 20, 50, 100];
  empresa: any;
  configImpressao: any;
  moduloFiadoAtivo = false;
  operadorTodos = {id: null, nome: 'Todos os operadores'};
  usuariosFiltro: any[] = [];
  filtro: any = {
    idOperador: null,
    dataAberturaInicio: null,
    dataAberturaFim: null,
    abertos: false
  };
  pageable: PagerSettings = {
    buttonCount: 5,
    info: true,
    type: 'numeric',
    pageSizes: this.pageSizes,
    previousNext: true
  };

  caixaDetalhado: any;
  resumoCaixaDetalhado: any;

  constructor(private caixaService: CaixaService, private impressaoService: ImpressaoService,
              private constantsService: ConstantsService, private dialogService: DialogService) {
    this.carregueOperadoresHistorico();
    this.carregueHistorico(this.skip, this.pageSize)
    this.constantsService.empresa$.subscribe( (empresa: any) => {
      if(empresa) {
        this.empresa = empresa
        this.configImpressao = this.empresa.configImpressao;
      }

    })
    this.constantsService.moduloFiado$.subscribe((ativo: boolean) => {
      this.moduloFiadoAtivo = ativo === true;
    });
  }

  ngOnInit(): void {
  }

  proximaPagina($event: PageChangeEvent) {
    this.skip = $event.skip;
    this.pageSize = $event.take;
    this.carregueHistorico(this.skip, this.pageSize);
  }

  private carregueHistorico(item: any, tamanho: number) {
    //carrega o historico paginado da empresa
    this.carregando = true
     this.caixaService.obtenhaHistoricoCaixas(item, tamanho, this.obtenhaFiltroHistorico()).then((historicoCaixas: any) => {
       this.historicoCaixas = {
         data: historicoCaixas.registros,
         total: historicoCaixas.quantidade
       };
       this.carregando = false;
     }).catch(() => {
       this.historicoCaixas = {
         data: [],
         total: 0
       };
       this.carregando = false;
     })
  }

  apliqueFiltros() {
    this.skip = 0;
    this.carregueHistorico(this.skip, this.pageSize);
  }

  limpeFiltros() {
    this.filtro = {
      idOperador: null,
      dataAberturaInicio: null,
      dataAberturaFim: null,
      abertos: false
    };
    this.apliqueFiltros();
  }

  private carregueOperadoresHistorico() {
    this.caixaService.listeOperadoresHistorico().then((operadores: any[]) => {
      this.usuariosFiltro = (operadores || []).map((operador: any) => this.normalizeOperadorFiltro(operador));
    }).catch(() => {
      this.usuariosFiltro = [];
    });
  }

  private normalizeOperadorFiltro(operador: any) {
    return {
      id: operador.id || operador.operador_id || operador.usuario_id,
      nome: operador.nome || operador.operador_nome || operador.usuario_nome || operador.email || operador.operador_email || '-'
    };
  }

  private obtenhaFiltroHistorico() {
    return {
      idOperador: this.filtro.idOperador,
      dataAberturaInicio: this.formateDataFiltro(this.filtro.dataAberturaInicio),
      dataAberturaFim: this.formateDataFiltro(this.filtro.dataAberturaFim, true),
      abertos: this.filtro.abertos
    };
  }

  private formateDataFiltro(data: Date, fimDoDia: boolean = false) {
    if(!data) return null;

    const dataFiltro = new Date(data);
    dataFiltro.setHours(0, 0, 0, 0);

    if(fimDoDia)
      dataFiltro.setDate(dataFiltro.getDate() + 1);

    return `${dataFiltro.getFullYear()}-${this.pad(dataFiltro.getMonth() + 1)}-${this.pad(dataFiltro.getDate())} ${this.pad(dataFiltro.getHours())}:${this.pad(dataFiltro.getMinutes())}:${this.pad(dataFiltro.getSeconds())}`;
  }

  private pad(valor: number) {
    return String(valor).padStart(2, '0');
  }

  verDetalhes(resumoCaixa: any) {
    this.caixaService.obtenhaCaixa(resumoCaixa.id).then((resposta: any) => {
      this.caixaDetalhado = resposta.caixa;
      this.resumoCaixaDetalhado = resposta.resumo;
    })
  }

  imprimir(resumoCaixa: any) {
    this.dialogRef = this.dialogService.open({
      content: this.templateref,
      actions: [],
      width: 300,
      height: 75,
      autoFocusedElement: 'none'
    });

    setTimeout(() => {
      this.dialogRef.close();
    }, 1500);

    if(this.configImpressao?.imprimirTXT)
      return this.impressaoNativa(resumoCaixa);

    this.abraRelatorioGrafico(resumoCaixa);
  }

  private async impressaoNativa(resumoCaixa: any) {
    const impressora = this.obtenhaImpressoraPadrao();

    if(!impressora)
      return this.impressaoService.onErrosImpressao.emit('Nenhuma impressora configurada');

    await this.impressaoService.imprimaResumoCaixa(resumoCaixa, impressora);
  }

  private abraRelatorioGrafico(resumoCaixa: any) {
    if(!resumoCaixa?.id)
      return this.impressaoService.onErrosImpressao.emit('Nao foi possivel identificar o caixa para impressao');

    const impressora = this.obtenhaImpressoraPadrao();
    const url = this.impressaoService.getRelatorioCaixaUrl({
      idCaixa: resumoCaixa?.id,
      idImpressora: impressora?.id || impressora?._id,
      a4: impressora?.tamanhoPapel === 'LayoutA4',
      autoPrint: true
    });

    window.open(url);
  }

  private obtenhaImpressoraPadrao() {
    return this.configImpressao?.impressoras?.[0];
  }

  fecharTransacoes() {
    this.caixaDetalhado = null;
    this.resumoCaixaDetalhado = null;

  }
}
